export interface Category {
  id: number;
  name: string;
  slug: string;
  icon: string;
  count: number;
  color: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: "热门推荐",
    slug: "remen",
    icon: "ri-fire-line",
    count: 12,
    color: "bg-primary-500",
  },
  {
    id: 2,
    name: "悬疑剧",
    slug: "xuanyi",
    icon: "ri-search-eye-line",
    count: 3,
    color: "bg-accent-500",
  },
  {
    id: 3,
    name: "古装剧",
    slug: "guzhuang",
    icon: "ri-ancient-gate-line",
    count: 5,
    color: "bg-secondary-500",
  },
  {
    id: 4,
    name: "都市剧",
    slug: "dushi",
    icon: "ri-building-2-line",
    count: 3,
    color: "bg-primary-400",
  },
  {
    id: 5,
    name: "科幻剧",
    slug: "kehuan",
    icon: "ri-rocket-line",
    count: 1,
    color: "bg-accent-400",
  },
  {
    id: 6,
    name: "爱情剧",
    slug: "aiqing",
    icon: "ri-heart-line",
    count: 2,
    color: "bg-primary-300",
  },
  {
    id: 7,
    name: "动漫",
    slug: "dongman",
    icon: "ri-movie-line",
    count: 0,
    color: "bg-secondary-400",
  },
  {
    id: 8,
    name: "综艺",
    slug: "zongyi",
    icon: "ri-tv-line",
    count: 0,
    color: "bg-accent-300",
  },
];